// HeroFeaturesB（Landing 版本 B）对比区结构化数据。
// 说明：本文件只保留「结构 / 非语言」字段（图片 src、gap 定位、severity 枚举、
// i18n key 引用），所有面向用户的文案均通过 i18n key 解析，便于多语言维护。
// 数据来源：result subject 2d9be7a0 的 AI job 缓存（analysisPayload.gaps[] 与
// analysisPayload.overview.postProcessingSuggestionsMd）。后续接入 B 结构化数据
// 管线时，可由数据驱动替换以下常量。

// 对比图：当前固定两张（raw / reference）。src 为非语言字段直接保留，
// altKey 指向 i18n 文案 key。
export const heroBComparisonImages = [
  {
    src: "https://img.photoscope.cc/landing/raw.webp",
    altKey: "landingB.heroB.comparison.rawAlt",
  },
  {
    src: "https://img.photoscope.cc/landing/reference.webp",
    altKey: "landingB.heroB.comparison.referenceAlt",
  },
];

// gap 标注：
// - severity 为枚举，复用 resultView.aiAnalysis.severity.* 的既有 i18n（major/moderate…）。
// - titleKey / briefKey / reasonKey 指向 landingB.heroB.gaps.* 文案。
// - pos 为标签在对比图上的临时定位（非语言字段）。
export const heroBGapAnnotations = [
  {
    id: "gap_1",
    severity: "major",
    titleKey: "landingB.heroB.gaps.gap_1.title",
    briefKey: "landingB.heroB.gaps.gap_1.brief",
    reasonKey: "landingB.heroB.gaps.gap_1.reason",
    pos: { top: "12%", left: "8%" },
  },
  {
    id: "gap_2",
    severity: "major",
    titleKey: "landingB.heroB.gaps.gap_2.title",
    briefKey: "landingB.heroB.gaps.gap_2.brief",
    reasonKey: "landingB.heroB.gaps.gap_2.reason",
    pos: { top: "26%", right: "8%" },
  },
  {
    id: "gap_3",
    severity: "major",
    titleKey: "landingB.heroB.gaps.gap_3.title",
    briefKey: "landingB.heroB.gaps.gap_3.brief",
    reasonKey: "landingB.heroB.gaps.gap_3.reason",
    pos: { bottom: "26%", left: "8%" },
  },
  {
    id: "gap_4",
    severity: "moderate",
    titleKey: "landingB.heroB.gaps.gap_4.title",
    briefKey: "landingB.heroB.gaps.gap_4.brief",
    reasonKey: "landingB.heroB.gaps.gap_4.reason",
    pos: { bottom: "12%", right: "8%" },
  },
];

// AI 后期分析（编辑建议）markdown 文案 key。
// 预览框取渲染前 2 行，hover 浮层渲染完整内容。
export const heroBAiGuideMdKey = "landingB.heroB.aiGuideMd";
